import { sidebarStore } from "Components/Core/Sidebar/SidebarStore";
import { MenuItemWithBadge, SubmenuItem } from "Components/Core/Sidebar/subMenus";
import { objectsAndDataStore } from "./Stores/ObjectsAndDataStore";

export const subMenuConfig = {
  get config(): SubmenuItem[] {
    const config = [];
    const mainModuleChildren = sidebarStore.menu?.find((m) => m.module === "VALUE_TABLE")?.children;

    mainModuleChildren.forEach((element) => {
      config.push({
        label: <MenuItemWithBadge label={element.module} />,
        link: `${element?.id}`,
        isActive: (link) => link.endsWith("values/" + objectsAndDataStore.currentRootId),
      });
    });

    return config;
  },
};
